<template>
	<v-container id="dashboard-view" fluid tag="section">
		<v-row class="mb-6" v-if="bankInfo">
			<v-col cols="12">
				<v-card>
					<v-row>
						<v-col cols="12" md="3">
							<v-img class="align-end text-white" height="200" contain :src="require('@/assets/online-payment.webp')">
							</v-img>
						</v-col>
						<v-col cols="12" md="9">
							<p style="white-space: pre-wrap;line-height: 35px;color: grey;padding: 5px;">
								{{ bankInfo }}
							</p>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
		<!-- 
		<v-row>
			<v-col v-for="(chart, i) in charts" :key="`chart-${i}`" cols="12" lg="6">
				<material-chart-card :color="chart.color" :data="chart.data" :options="chart.options" :responsive-options="chart.responsiveOptions" :title="chart.title" :type="chart.type">
					<template #subtitle>
						<div class="font-weight-light text--secondary">
							<div v-html="chart.subtitle" />
						</div>
					</template>
</material-chart-card>
</v-col>
</v-row> -->

		<v-row>
			<v-col cols="12">
				<MemberLoanOverview />
			</v-col>
		</v-row>

		<v-row>
			<v-col v-for="({ actionIcon, actionText, ...attrs }, i) in memberStats" :key="i" cols="12" md="6" lg="3">
				<material-stat-card v-bind="attrs">
					<template #actions>
						<v-icon class="mr-2" small v-text="actionIcon" />
						<div class="text-truncate" v-html="actionText" />
					</template>
				</material-stat-card>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogNoLoanRequestAlert" scrollable max-width="450px">
			<v-card>
				<v-card-title>
					<span class="headline">توجه</span>
					<v-spacer />
					<v-btn @click="dialogNoLoanRequestAlert = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<div class="pa-3 text-right">
							کاربر گرامی، تاکنون درخواست وامی ثبت نکرده اید، آیا مایل به ثبت درخواست جدید هستید؟
						</div>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="blue" :loading="routeToLoanRequestsLoading" dark @click="routeToLoanRequests">
						بله
					</v-btn>
					<v-btn @click="dialogNoLoanRequestAlert = false">
						خیر
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	// Utilities
	import { get } from 'vuex-pathify'
	import Vue from 'vue'
	import api from '@/util/app-api'
	import router from '@/router'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import MemberLoanOverview from '@/components/MemberLoanOverview.vue'

	const lineSmooth = Vue.chartist.Interpolation.cardinal({
		tension: 0,
	})

	export default {
		name: 'MemberDashboardView',
		components: {
			MemberLoanOverview,
		},
		data: () => ({
			dialogNoLoanRequestAlert: false,
			routeToLoanRequestsLoading: false,
			charts: {
				payment: {
					type: 'Line',
					color: 'success',
					title: 'نمودار اقساط پرداختی',
					subtitle: 'نمودار مبالغ اقساط پرداختی در یکسال گذشته ',
					data: {
						labels: [],
						series: [
							[],
						],
					},
					options: {
						lineSmooth,
						low: 0,
						high: 100000000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0,
						},
						axisY: {
							offset: 90,
							labelInterpolationFnc: function (value) {
								return value.toString().toPriceFormat()
							},
						},
					},
				},
				savedmoney: {
					type: 'Line',
					color: 'info',
					title: 'نمودار پس انداز ها',
					subtitle: 'نمودار پس انداز های ثبت شده در یکسال گذشته ',
					data: {
						labels: [],
						series: [[]],
					},
					options: {
						lineSmooth,
						low: 0,
						high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0,
						},
						axisY: {
							offset: 90,
							labelInterpolationFnc: function (value) {
								return value.toString().toPriceFormat()
							},
						},
					},
				},
			},
			items: [],
			monthStat: {
				actionIcon: 'mdi-calendar',
				actionText: '',
				color: '#FD9A13',
				icon: 'mdi-scale-balance',
				title: '',
				value: '',
				monthInstallments: 0,
				monthInstallmentsCounts: 0,
				monthSaveds: 0,
				monthSavedsCounts: 0,
				monthBalance: 0,
			},
			memberStats: {
				loans: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع وام های دریافت شده',
					color: 'primary',
					icon: 'mdi-account-cash',
					title: 'مجموع وام ها',
					value: '',
				},
				paids: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع اقساط پرداخت شده',
					color: 'success',
					icon: 'mdi-cash-check',
					title: 'مجموع پرداخت ها',
					value: '',
				},
				unpaids: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع باقیمانده اقساط وام ها',
					color: 'info',
					icon: 'mdi-cash-remove',
					title: 'باقیمانده اقساط ',
					value: '',
				},
				saved: {
					actionIcon: 'mdi-tag',
					actionText: '<a href="#">مشاهده جزئیات</a>',
					color: 'info',
					icon: 'mdi-cash-multiple',
					title: 'موجودی پس انداز',
					value: '',
				},
				ticket: {
					actionIcon: 'mdi-tag',
					actionText: 'تیکت های پاسخ داده شده',
					color: 'green',
					icon: 'mdi-email-fast',
					iconSmall: true,
					title: 'تیکت ها',
					value: '',
					count: '0'
				}
			},
			tabs: 0,
			systemStats: {
				loans: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع کل مبلغ وام های اعطا شده',
					color: 'primary',
					icon: 'mdi-account-cash',
					title: 'مجموع وام ها',
					value: '',
				},
				paids: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع کل مبلغ اقساط پرداخت شده',
					color: 'success',
					icon: 'mdi-cash-check',
					title: 'مجموع اقساط پرداختی',
					value: '',
				},
				unpaids: {
					actionIcon: 'mdi-tag',
					actionText: 'مبلغ کل باقیمانده اقساط',
					color: 'info',
					icon: 'mdi-cash-remove',
					title: 'مجموع باقیمانده ها',
					value: '',
				},
				saved: {
					actionIcon: 'mdi-tag',
					actionText: 'مجموع پس انداز های موجود صندوق',
					color: 'info',
					icon: 'mdi-cash-multiple',
					title: 'مجموع پس انداز ها',
					value: '',
				},
			},
			expenseStat: {
				actionIcon: 'mdi-tag',
				actionText: 'مجموع 1 درصد از وام ها بابت هزینه های صندوق',
				color: 'info',
				icon: 'mdi-flower-tulip',
				title: '',
				value: '',
				costShare: 0,
				expense: 0,
				remain: 0,
			},
			checkoutStats: {
				checkoutedThisMonth: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'primary',
					icon: 'mdi-account-cash',
					title: '',
					value: '',
				},
				allCheckouted: {
					actionIcon: 'mdi-tag',
					actionText: '',
					color: 'info',
					icon: 'mdi-account-cash',
					title: '',
					value: '',
				},
			},
		}),

		computed: {
			...get('memberAppSettings', [
				'bankInfo', 'showSubmitFirstLoanRequestNotifInMemberPanel'
			]),
			sales: get('sales/sales'),
			totalSales() {
				return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
			},
		},

		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				api.get('member/dashboard/get', null)
					.then(
						response => {
							const savedMoneyChartData = { labels: [], series: [] }
							let high1 = 0
							if (response.savedMoneyChart) {
								const series = []
								for (let i = 0; i < response.savedMoneyChart.length; i++) {
									savedMoneyChartData.labels.push(response.savedMoneyChart[i].month)
									series.push(response.savedMoneyChart[i].amount)
									high1 = Math.max(high1, response.savedMoneyChart[i].amount)
								}
								savedMoneyChartData.series.push(series)
							}

							const paymentChartData = { labels: [], series: [] }
							let high2 = 0
							if (response.paymentChart) {
								const series = []
								for (let i = 0; i < response.paymentChart.length; i++) {
									paymentChartData.labels.push(response.paymentChart[i].month)
									series.push(response.paymentChart[i].amount)
									high2 = Math.max(high2, response.paymentChart[i].amount)
								}
								paymentChartData.series.push(series)
							}
							this.charts.savedmoney.data = savedMoneyChartData
							this.charts.savedmoney.options.high = high1
							this.charts.payment.data = paymentChartData
							this.charts.payment.options.high = high2

							this.memberStats.loans.value = response.memberTotalLoans.toString().toPriceFormat() + '<br/> تومان'
							this.memberStats.paids.value = response.memberTotalPaid.toString().toPriceFormat() + '<br/> تومان'
							this.memberStats.unpaids.value = response.memberTotalUnpaid.toString().toPriceFormat() + '<br/> تومان'
							this.memberStats.saved.value = response.memberTotalSave.toString().toPriceFormat() + '<br/> تومان'
							this.memberStats.ticket.value = response.ticketsCount.toString()

							this.systemStats.loans.value = response.totalLoans.toString().toPriceFormat() + '<br/> تومان'
							this.systemStats.paids.value = response.totalPaid.toString().toPriceFormat() + '<br/> تومان'
							this.systemStats.unpaids.value = response.totalUnpaid.toString().toPriceFormat() + '<br/> تومان'
							this.systemStats.saved.value = response.totalSave.toString().toPriceFormat() + '<br/> تومان'

							this.checkoutStats.checkoutedThisMonth.value = response.checkoutedThisMonthCount
							this.checkoutStats.allCheckouted.value = response.allCheckoutedCount

							this.monthStat.monthInstallments = response.monthInstallments
							this.monthStat.monthInstallmentsCounts = response.monthInstallmentsCounts
							this.monthStat.monthSaveds = response.monthSaveds
							this.monthStat.monthSavedsCounts = response.monthSavedsCounts
							this.monthStat.monthBalance = response.monthBalance
							this.monthStat.actionText = `آخرین ماه دریافت شده: ${response.lastMonthPersianDate.monthName} ${response.lastMonthPersianDate.year}`
							this.lastMonthPersianDate = response.lastMonthPersianDate.date

							this.expenseStat.costShare = response.costShare
							this.expenseStat.expense = response.expense
							this.expenseStat.remain = response.costShare - response.expense



							if ((response.loanRequestCount + response.memberTotalLoans) === 0 && this.showSubmitFirstLoanRequestNotifInMemberPanel) {
								this.routeToLoanRequestsLoading = false
								this.dialogNoLoanRequestAlert = true
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			routeToLoanRequests() {
				this.routeToLoanRequestsLoading = true
				router.push({ path: `/member/LoanRequest/${emptyId}` }).catch(() => { })
			},
			routeToTickets() {
				router.push({ path: '/Agent/Tickets' }).catch(() => { })
			},
		}
	}
</script>
<style>

	svg.ct-chart-bar,
	svg.ct-chart-line {
		overflow: visible;
	}

	.ct-label.ct-label.ct-horizontal.ct-end {
		position: relative;
		justify-content: flex-end;
		text-align: right;
		transform-origin: 100% 0;
		transform: translate(-100%) rotate(-45deg);
		white-space: nowrap;
	}

	.ct-label.ct-vertical.ct-start {
		white-space: pre;
		transform: translateX(-5px);
	}
</style>
